/**
 * OPEN-157 — the office's half of "Correct driver" on a finished ticket: the reason floor and
 * the words for a refusal (api services/job-driver-correction.ts is the source of truth).
 */

import { ApiError } from '@lodex-pro/web-shared';

/** The route's reason floor. */
export const DRIVER_CORRECTION_REASON_MIN = 10;

const REFUSAL_COPY: Readonly<Record<string, string>> = {
  job_not_finished: 'Only a finished ticket’s driver is corrected here.',
  same_driver: 'Choose a different driver.',
  driver_not_found: 'That person is not a driver at this company.',
};

/** The line for a failed correction. */
export function driverCorrectionErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const reason = err.fields[0]?.reason;
    // The API names the invoice ("On invoice INV-12 (SENT). Void it to correct the driver.").
    if (err.code === 'TICKET_ON_INVOICE') {
      return reason ?? 'This ticket is on an invoice. Void the invoice to correct the driver.';
    }
    if (err.code === 'PERMISSION_DENIED') return 'You can’t correct the driver on a ticket.';
    if (reason !== undefined && REFUSAL_COPY[reason] !== undefined) return REFUSAL_COPY[reason];
  }
  return 'Could not correct the driver. Try again.';
}
